import {usePermissions} from '@/hooks/usePermissions';

/**
 * Renders children only when the user satisfies the permission requirements.
 *
 * Props:
 *   permission  {string}          – single gest_* permission required
 *   permissions {string[]}        – require ALL of these
 *   any         {string[]}        – require ANY of these
 *   fallback    {React.ReactNode} – rendered when access is denied (default: null)
 *
 * Examples:
 *   <PermissionGate permission="gest_resource_create">
 *     <Button>Novo Veículo</Button>
 *   </PermissionGate>
 *
 *   <PermissionGate any={['gest_incident_create', 'gest_incident_update']}>
 *     <IncidentForm />
 *   </PermissionGate>
 */
export const PermissionGate = ({
                                   permission,
                                   permissions,
                                   any,
                                   fallback = null,
                                   children,
                               }) => {
    const {can, canAll, canAny} = usePermissions();

    if (permission && !can(permission)) return fallback;
    if (permissions && !canAll(...permissions)) return fallback;
    if (any && !canAny(...any)) return fallback;

    return children;
};